/**
 * Base URL Interceptor
 * 相対パスのリクエストに対してBase URLを自動付与する
 */

import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '../../../environments/environment';

export const baseUrlInterceptor: HttpInterceptorFn = (req, next) => {
  // ローカル配信する更新情報ファイルは API Base URL を付与しない
  if (req.url === '/version.json' || req.url === 'version.json') {
    return next(req);
  }

  // 絶対URLまたはプロトコル相対URLの場合はそのまま通す
  if (
    req.url.startsWith('http://') ||
    req.url.startsWith('https://') ||
    req.url.startsWith('//')
  ) {
    return next(req);
  }

  // 相対パスにBase URLを付与
  const baseUrl = environment.api.baseUrl.endsWith('/')
    ? environment.api.baseUrl
    : environment.api.baseUrl + '/';
  const url = req.url.startsWith('/') ? req.url.slice(1) : req.url;

  const cloned = req.clone({ url: baseUrl + url });
  return next(cloned);
};
